/* global window */
import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title } from 'common/components/layout';
import { validateMagicLinkId } from 'redux/customer/actions';

class ResetPassword extends Component {
  componentDidMount() {
    const { props } = this;
    const { magicLinkId } = props.match.params;
    const errorFunction = () => {
      props.history.push('/profile/magic-link-error');
    };
    const successFunction = (response) => {
      if (response.redirectLink) {
        window.location.href = response.redirectLink;
      } else {
        props.history.push('/profile');
      }
    };
    props.validateMagicLinkId(magicLinkId, successFunction, errorFunction);
  }

  render() {
    const { customer, settings } = this.props;
    if (!settings.data) {
      return (
        <Layout title="Magic Link" loading>
          <Title>Magic Link</Title>
        </Layout>
      );
    }
    if (!customer) {
      return <div>Loading...</div>;
    }
    if (customer && !customer.firstName) {
      // return <CreateAccountForm resetPasswordId={resetPasswordId} />;
      return (
        <Layout title="Magic Link">
          <Title>Magic Link</Title>
          Activated
        </Layout>
      );
    }
    if (customer && customer.firstName) {
      return (
        <Layout title="Magic Link">
          <Title>Magic Link</Title>
          Activated
        </Layout>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer.data,
  settings: state.setting
});

export default connect(mapStateToProps, { validateMagicLinkId })(ResetPassword);
